import React from 'react';
import { useTheme } from 'styled-components';
import { StyledSVG } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const Icon = ({ size, name, className, 'data-testid': dataTestId, margin }) => {
    const theme = useTheme();
    const cleanedBasePath = theme.iconBasePath?.replace(/\/$/, '');
    const url = `${cleanedBasePath}/${name}-${size}.svg#main`;
    const sizeMap = {
        xs: '16px',
        s: '24px',
        l: '48px'
    };
    return (React.createElement(StyledSVG, { fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true, "data-testid": dataTestId, width: sizeMap[size], height: sizeMap[size], className: className, margin: margin },
        React.createElement("use", { href: url })));
};
//# sourceMappingURL=index.js.map